import React from 'react'
import { useTranslation } from 'react-i18next';
import DocumentationSidebar from '../component/DocumentationSidebar'
import { useDocImage } from '../hooks/useDocImage';

export default function ReportBuilder() {
  const { t } = useTranslation();
  const image001 = useDocImage('report-builder-img', 'image001.png');
  const image002 = useDocImage('report-builder-img', 'image002.png');
  const image004 = useDocImage('report-builder-img', 'image004.png');
  const image005 = useDocImage('report-builder-img', 'image005.png');
  const image006 = useDocImage('report-builder-img', 'image006.png');
  const image007 = useDocImage('report-builder-img', 'image007.png');
  const image008 = useDocImage('report-builder-img', 'image008.png');
  const image009 = useDocImage('report-builder-img', 'image009.png');
  const image010 = useDocImage('report-builder-img', 'image010.png');
  const image011 = useDocImage('report-builder-img', 'image011.png');
  const image012 = useDocImage('report-builder-img', 'image012.png');
  const image014 = useDocImage('report-builder-img', 'image014.png');
  const image015 = useDocImage('report-builder-img', 'image015.png');
  const image017 = useDocImage('report-builder-img', 'image017.png');
  const image018 = useDocImage('report-builder-img', 'image018.png');

  return (
    <>
      <div className='d-flex flex-column main-outer-wrapper'>
        <div className="flex-grow-1 d-flex survey-main-wrapper">
          <DocumentationSidebar />

          {/* Dashboard Content */}
          <div className="flex-grow-1 dashboard-page-outer">
            <div className='dashboard-page-wrap document-page-wrap'>

              <h1 className='mt-0 text-primary'>{t('documentation.reportBuilder.title')}</h1>
              <p className='header-para'>
                {t('documentation.reportBuilder.intro')}
              </p>

              <h5>{t('documentation.reportBuilder.featuresTitle')}</h5>
              <img src={image017} alt={t('documentation.reportBuilder.builder.imageAlt')} className='pb-30 pt-20 w-60' />
              <p> {t('documentation.reportBuilder.features.edit')}</p>

              <p> {t('documentation.reportBuilder.features.duplicate')}</p>

              <p>{t('documentation.reportBuilder.features.default')}</p>

              <p className='pb-20'>{t('documentation.reportBuilder.features.delete')}</p>

              <div className="card dashboard-card mb-4">
                <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                  {t('documentation.reportBuilder.builder.title')}
                </div>
                <div className="card-body">

                  <ul>
                    <li>  {t('documentation.reportBuilder.builder.step1')}
                      <img src={image018} alt={t('documentation.reportBuilder.builder.imageAlt')} className='img-fluid pb-20 pt-20 w-90' />
                    </li>
                    <li>{t('documentation.reportBuilder.builder.step2')} <br />
                      <img src={image001} alt={t('documentation.reportBuilder.builder.imageAlt')} className='img-fluid pb-20 pt-20 ' />
                    </li>

                  </ul>

                </div>
              </div>


              <div className="card dashboard-card mb-4">
                <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                  {t('documentation.reportBuilder.editorView.title')}
                </div>
                <div className="card-body">
                  <p>{t('documentation.reportBuilder.editorView.intro')}</p>
                  <ul>
                    <img src={image002} alt={t('documentation.reportBuilder.builder.imageAlt')} className='img-fluid pt-20 pb-20' />
                    <li>{t('documentation.reportBuilder.editorView.items.responsive')}</li>
                    <li>{t('documentation.reportBuilder.editorView.items.highlight')}</li>
                    <li>{t('documentation.reportBuilder.editorView.items.preview')}</li>
                    <li>{t('documentation.reportBuilder.editorView.items.fullscreen')}</li>
                    <li>{t('documentation.reportBuilder.editorView.items.viewCode')}</li>
                    <li>{t('documentation.reportBuilder.editorView.items.undoRedo')}</li>
                    <li>{t('documentation.reportBuilder.editorView.items.download')}</li>
                    <li>{t('documentation.reportBuilder.editorView.items.deleteAll')}</li>
                    <li>{t('documentation.reportBuilder.editorView.items.blocks')}</li>
                  </ul>

                </div>
              </div>

              <div className="card dashboard-card mb-4">
                <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                  {t('documentation.reportBuilder.basicElements.title')}
                </div>
                <div className="card-body">

                  <ul>
                    <img src={image004} alt={t('documentation.reportBuilder.builder.imageAlt')} className='pb-10 pt-10' /><br />
                    <img src={image005} alt={t('documentation.reportBuilder.builder.imageAlt')} className=' pb-30 ' />
                    <li>{t('documentation.reportBuilder.basicElements.items.columns')}</li>
                    <li>{t('documentation.reportBuilder.basicElements.items.text')}</li>
                    <li>{t('documentation.reportBuilder.basicElements.items.link')}</li>
                    <li>{t('documentation.reportBuilder.basicElements.items.media')}</li>
                  </ul>

                  <p><b>{t('documentation.reportBuilder.formElements.title')}</b></p>
                  <ul>
                    <img src={image006} alt={t('documentation.reportBuilder.builder.imageAlt')} className='pb-10 pt-20' /> <br />
                    <img src={image007} alt={t('documentation.reportBuilder.builder.imageAlt')} className='pb-30' />
                    <li>{t('documentation.reportBuilder.formElements.items.intro')}</li>
                    <li>{t('documentation.reportBuilder.formElements.items.types')}</li>
                  </ul>

                  <p><b>{t('documentation.reportBuilder.extraElements.title')}</b></p>
                  <ul>
                    <img src={image009} alt={t('documentation.reportBuilder.builder.imageAlt')} className='pb-10 pt-20' /> <br />
                    <img src={image008} alt={t('documentation.reportBuilder.builder.imageAlt')} className=' pb-30' />
                    <li>{t('documentation.reportBuilder.extraElements.items.tooltip')}</li>
                    <li>{t('documentation.reportBuilder.extraElements.items.countdown')}</li>
                    <li>{t('documentation.reportBuilder.extraElements.items.customCode')}</li>
                    <li>{t('documentation.reportBuilder.extraElements.items.typed')}</li>
                    <li>{t('documentation.reportBuilder.extraElements.items.tabs')}</li>
                  </ul>

                </div>
              </div>

              <div className="card dashboard-card mb-4">
                <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                  {t('documentation.reportBuilder.customization.title')}
                </div>
                <div className="card-body">
                  <p>{t('documentation.reportBuilder.customization.intro')}</p>
                  <img src={image010} alt={t('documentation.reportBuilder.builder.imageAlt')} className='pb-30 pt-20' />
                  <p> <b>{t('documentation.reportBuilder.customization.generalTitle')}</b>  -  {t('documentation.reportBuilder.customization.generalDesc')}</p>
                  <p><b>{t('documentation.reportBuilder.customization.positionTitle')}</b> </p>
                  <ul>

                    <li>{t('documentation.reportBuilder.customization.positionItems.static')}</li>
                    <li>{t('documentation.reportBuilder.customization.positionItems.relative')}</li>
                    <li>{t('documentation.reportBuilder.customization.positionItems.absolute')}</li>
                    <li>{t('documentation.reportBuilder.customization.positionItems.fixed')}</li>
                  </ul>

                  <p><b>{t('documentation.reportBuilder.customization.floatDisplayTitle')}</b>
                  </p>
                   <p> {t('documentation.reportBuilder.customization.floatDisplayIntro')}</p>

                  <ul>

                    <li>{t('documentation.reportBuilder.customization.floatItem')}</li>
                    <li> {t('documentation.reportBuilder.customization.displayItem')}
                      <ul className='pt-10'>
                        <li>{t('documentation.reportBuilder.customization.displaySubItems.block')}</li>
                        <li>{t('documentation.reportBuilder.customization.displaySubItems.inline')}</li>
                        <li>{t('documentation.reportBuilder.customization.displaySubItems.none')}</li>
                      </ul>
                    </li>
                  </ul>

                  <p><b> {t('documentation.reportBuilder.customization.dimensionTitle')} </b> - {t('documentation.reportBuilder.customization.dimensionDesc')} </p>
                  <img src={image011} alt={t('documentation.reportBuilder.builder.imageAlt')} className='pt-20 pb-30' />

                  <p>{t('documentation.reportBuilder.customization.dimensionIntro')}</p>
                  <ul>
                    <li>{t('documentation.reportBuilder.customization.dimensionItems.width')}</li>
                    <li>{t('documentation.reportBuilder.customization.dimensionItems.maxWidth')}</li>
                    <li>{t('documentation.reportBuilder.customization.dimensionItems.maxHeight')}</li>
                    <li>{t('documentation.reportBuilder.customization.dimensionItems.margin')}</li>
                    <li>{t('documentation.reportBuilder.customization.dimensionItems.padding')}</li>
                    <li>{t('documentation.reportBuilder.customization.dimensionItems.note')}</li>
                  </ul>

                </div>
              </div>

              <div className="card dashboard-card mb-4">
                <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                  {t('documentation.reportBuilder.typography.title')}
                </div>
                <div className="card-body">
                  <p>{t('documentation.reportBuilder.typography.intro')}</p>
                  <ul>
                    <img src={image012} alt={t('documentation.reportBuilder.builder.imageAlt')} className='pb-30 pt-20' />
                    <li>{t('documentation.reportBuilder.typography.items.fontFamily')}</li>
                    <li>{t('documentation.reportBuilder.typography.items.fontSize')}</li>
                    <li>{t('documentation.reportBuilder.typography.items.fontWeight')}</li>
                    <li>{t('documentation.reportBuilder.typography.items.letterSpacing')}</li>
                    <li>{t('documentation.reportBuilder.typography.items.color')}</li>
                    <li>{t('documentation.reportBuilder.typography.items.lineHeight')}</li>
                    <li>{t('documentation.reportBuilder.typography.items.textAlign')}</li>
                    <li>{t('documentation.reportBuilder.typography.items.textShadow')}</li>

                  </ul>

                  <p> <b>{t('documentation.reportBuilder.typography.decorationsTitle')}</b> </p>
                  <ul>
                    <img src={image014} alt={t('documentation.reportBuilder.builder.imageAlt')} className='pt-20 pb-30' /><br />

                    <li>{t('documentation.reportBuilder.typography.decorationsItems.backgroundColor')}</li>
                    <li>{t('documentation.reportBuilder.typography.decorationsItems.border')}</li>
                    <li>{t('documentation.reportBuilder.typography.decorationsItems.borderRadius')}</li>
                    <li>{t('documentation.reportBuilder.typography.decorationsItems.boxShadow')}</li>
                    <li>{t('documentation.reportBuilder.typography.decorationsItems.background')}</li>
                    <li>{t('documentation.reportBuilder.typography.decorationsItems.gradient')}</li>
                    <li>{t('documentation.reportBuilder.typography.decorationsItems.note')}</li>


                  </ul>

                  <p> <b>{t('documentation.reportBuilder.typography.extraTitle')}</b> </p>
                  <ul>
                    <img src={image015} alt={t('documentation.reportBuilder.builder.imageAlt')} className='pt-20 pb-20' /><br />

                    <li>{t('documentation.reportBuilder.typography.extraItems.opacity')}</li>
                    <li>{t('documentation.reportBuilder.typography.extraItems.transitions')}</li>
                    <li> {t('documentation.reportBuilder.typography.extraItems.transform')} <br />
                      <ul className='pt-10'>
                        <li>{t('documentation.reportBuilder.typography.extraItems.transformDetails.layout')}</li>
                        <li>{t('documentation.reportBuilder.typography.extraItems.transformDetails.dimensions')}</li>
                        <li>{t('documentation.reportBuilder.typography.extraItems.transformDetails.variables')}</li>
                        <li>{t('documentation.reportBuilder.typography.extraItems.transformDetails.formulas')}</li>
                        <li>{t('documentation.reportBuilder.typography.extraItems.transformDetails.stages')}</li>
                        <li>{t('documentation.reportBuilder.typography.extraItems.transformDetails.recommendations')}</li>
                        <li>{t('documentation.reportBuilder.typography.extraItems.transformDetails.overview')}</li>
                        <li>{t('documentation.reportBuilder.typography.extraItems.transformDetails.sequence')}</li>
                      </ul>

                    </li>
                  </ul>

                  <p>{t('documentation.reportBuilder.typography.note')}</p>
                </div>
              </div>

            </div>
          </div>

        </div>
      </div>
    </>
  )
}
